<script setup>
// The header of every Teletel settings page. Same size, weight, spacing and
// divider as BaseSettingsHeader on the core settings pages (owner order
// 2026-09-14: one look for old and new pages), with an actions slot on the
// title row.
defineProps({
  title: { type: String, required: true },
  description: { type: String, default: '' },
});
</script>

<template>
  <header class="flex w-full flex-col items-start border-b border-n-weak pb-5">
    <div class="mb-2 flex min-h-9 w-full items-center justify-between gap-4">
      <h1
        class="text-heading-1 font-semibold tracking-tight text-n-slate-12 min-w-0"
      >
        {{ title }}
      </h1>
      <div v-if="$slots.actions" class="flex flex-shrink-0 flex-wrap gap-2">
        <slot name="actions" />
      </div>
    </div>
    <p
      v-if="description"
      class="mb-0 max-w-3xl text-body-main leading-6 text-n-slate-11"
    >
      {{ description }}
    </p>
  </header>
</template>
